export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/70 pt-14 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10 md:mb-14">
          <div>
            <div className="flex items-center gap-2 mb-3 md:mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-lg"></i>
              </div>
              <span className="text-lg font-heading text-background-50">牛牛影视</span>
            </div>
            <p className="text-xs md:text-sm leading-relaxed mb-4">
              牛牛超清不缓冲流畅播放平台，提供高清电影、电视剧全集免费在线观看。告别卡顿，沉浸式追剧观影首选。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-heading text-background-50 mb-3 md:mb-4">快速导航</h3>
            <div className="space-y-2">
              {[
                { label: '首页', href: '#hero' },
                { label: '热门话题', href: '#topics' },
                { label: '热度榜单', href: '#ranking' },
                { label: '热门影视', href: '#cards' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="block text-xs md:text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading text-background-50 mb-3 md:mb-4">影视分类</h3>
            <div className="space-y-2">
              {['动作大片', '爱情甜剧', '悬疑烧脑', '科幻巨制', '古装经典', '动漫番剧', '纪录纪实'].map((cat) => (
                <a
                  key={cat}
                  href="#cards"
                  onClick={(e) => handleNavClick(e, '#cards')}
                  className="block text-xs md:text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading text-background-50 mb-3 md:mb-4">合作伙伴</h3>
            <p className="text-xs md:text-sm text-background-50/40 leading-relaxed">
              更多优质合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6 md:pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40 text-center sm:text-left">
            &copy; 2026 牛牛影视 · 高清电影电视剧免费在线观看全集
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-50/30">牛牛超清</span>
            <span className="text-xs text-background-50/30">牛牛极清</span>
            <span className="text-xs text-background-50/30">牛牛不缓冲</span>
          </div>
        </div>
      </div>
    </footer>
  );
}